<template>
    <div class="historico-importacao">
        <ContainerTitle icon="clock" title="Histórico de carga"/>

        <HistoricoImportacaoFilter @filter-historico-importacao="filtrar" />
        <HistoricoImportacaoList :rows="rows"/>
        
        <ModalAlert id="historico-importacao-list-vazio" @close="$bvModal.hide('historico-importacao-list-vazio')">
            <DynamicIcon icon="exclamation" :classString="'alert-exclamation'"/>
            Não existe histórico de carga para o(s) filtro(s) selecionado(s).
        </ModalAlert>
        
        <PaginationTable :page="page" :totalPages="result.totalPages" :totalItens="result.totalItens" @changePage="changePage" 
            />
    </div>
</template>
<script>

import HistoricoImportacaoFilter from './components/HistoricoImportacaoFilter.vue'
import  HistoricoImportacaoList from './components/HistoricoImportacaoList.vue'
import ModalAlert from "../../../../commons/ModalAlert.vue"
import BeneficiarioImportacaoResource from "@/resources/BeneficiarioImportacaoResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ContainerTitle from "@/components/commons/ContainerTitle.vue";
import PaginationTable from "@/components/commons/table/components/PaginationTable.vue";
import { formateDate, formateHours } from "./../../../../../util/BeneficiarioUtils.js";


export default {
    name: 'HistoricoImportacao',
    components: {
       HistoricoImportacaoList,
       HistoricoImportacaoFilter,
       ModalAlert,
       DynamicIcon,
       ContainerTitle,
       PaginationTable
    },
	data() {
		return {
            rows: [],
            result: {
				list: [],
				totalPages: 0,
				totalItens: 0
			},
            historicoIdEdition: null,
			historicoIdDeletion: null,
			historicoPerfisEdition: null,
			showModalForm: null,
			page: 1,
			filterForm: {}
		}
	},
    methods: {	
		changePage( page ){
			this.page = page
			this.filtrar()
		},
        filtrar(formFilter) 
        {
			this.lastFilter = {...formFilter}
			let filter = {
				page: this.page,
				...formFilter
			}

			BeneficiarioImportacaoResource.getHistoricoImportacao(filter.empresaId, filter.email, filter.name, filter.periodo, filter.produto, filter.page, filter.size, {showLoader: true})
			.then((result) => {
                if(!Array.isArray(result.list))
                {
                    this.rows = [];
                }

                if(!result.list.length)
                {
                    this.$bvModal.show("historico-importacao-list-vazio");
                }

                this.result = result
                
                const _status = { 
                    QUEUE_FILE : 'Aguardando processamento',
                    PRE_IMPORTING : 'Pre importação',
                    WAINTING_START: 'Aguardando inicialização',
                    IMPORTING : 'Em execução',
                    FINISHED : 'Finalizada',
                    CANCELED: 'Cancelada',
                    QUEUE_FILE_ERROR: 'Erro durante execução' 
                }

                this.rows = result.list.map( elem =>  { 
                    return {
                        id: elem?.historico?.id,
                        empresaId : elem?.historico?.empresaId,
                        text: elem?.empresa?.text,
                        userEmail: elem?.historico?.userEmail,
                        userName: elem?.historico?.userName,
                        totalLinhas : elem?.historico?.totalLinhas,
                        totalTitulares : elem?.historico?.totalTitulares,
                        totalCpfUnicos : elem?.historico?.totalCpfUnicos,
                        totalDependentes: elem?.historico?.totalDependentes,
                        totalImportados:  elem?.historico?.totalImportados,
                        totalNaoImportados : elem?.historico?.totalNaoImportados,
                        fileNameOriginal: elem?.historico?.fileNameOriginal,
                        produtos: elem?.produtos,
                        tipoImportacao: this.tipoImportacao(elem?.historico?.tipoImportacao),
                        status: _status[elem?.historico?.status]  ? _status[elem?.historico?.status] : "",
                        dataHora: `${formateDate(elem?.historico?.lastUpdate)} ${formateHours(elem?.historico?.lastUpdate)}`
                    }
                })
			})
            .catch(()=>{
                this.rows = []
            })
		},
        tipoImportacao(tipo) {
            if(tipo == 'IMPORT_REPLACE')
                return "Full"
            
            if(tipo == 'IMPORT_CONCAT')
                return "Incremental"

            return null
        }
    },
    mounted() {
        this.filtrar(this.filterForm);
    }
}

</script>

<style scoped>
.historico-importacao {
    color: #707070;
	font-size: 18px;
	text-align: left;
    background-color: #fff;
}
</style>